import { CheckCircle } from '@phosphor-icons/react';
import PrimaryButton from '../../../components/atoms/Button';
import { SyncStatusWidget } from '../sync-status/components/SyncStatusWidget';

type SATAlreadyLinkedSuccessProps = {
	onContinue: () => void;
};

const SATAlreadyLinkedSuccess = ({
	onContinue,
}: SATAlreadyLinkedSuccessProps) => {
	return (
		<section className='px-3 py-6 max-w-[600px] mx-auto flex flex-col gap-6 fade-in-scale'>
			<div className='text-center flex flex-col gap-2'>
				<h2 className='text-h-text-heading text-xl md:text-2xl font-bold'>
					Conectaste tu cuenta del SAT exitosamente
				</h2>
				<p className='text-h-text-medium text-sm'>
					Estamos sincronizando tu información fiscal. Puedes continuar sin
					esperar.
				</p>
			</div>

			<SyncStatusWidget />

			<PrimaryButton
				label='Continuar'
				onClick={onContinue}
				icon={<CheckCircle weight='fill' size={20} className='opacity-50' />}
			/>
		</section>
	);
};

export default SATAlreadyLinkedSuccess;
